import { useState } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';

const TalentCard = dynamic(() => import('@components/TalentCard/TalentCard'), {
  ssr: false,
});

import Styles from './Styles.module.scss';

const SubTalentTypeList = ({ users, showPortfolio, analyticsData, isPrivate, ...props }) => {
  const [talentCards, setTalentCards] = useState();

  const showTalents = () => {
    const items = [];
    users.map((user) =>
      items.push(
        // FIXME: this will have to be different based on user.type
        <TalentCard
          isPrivate={isPrivate}
          key={user.username}
          user={user}
          showPortfolio={showPortfolio}
          analyticsData={analyticsData}
        />
      )
    );
    setTalentCards(items);
  };

  if (!talentCards && users?.length) {
    showTalents();
  }
  return (
    <div className={Styles.talentList} {...props}>
      {talentCards}
    </div>
  );
};

SubTalentTypeList.propTypes = {
  users: PropTypes.array,
  showReviewsSection: PropTypes.bool,
  showPortfolio: PropTypes.bool,
  isPrivate: PropTypes.bool,
};

export default SubTalentTypeList;
